import { addDays, startOfDay } from "date-fns";

export const THREE_DAY_VIEW = "threeDay" as const;
export type ThreeDayViewName = typeof THREE_DAY_VIEW;

export const getThreeDayRange = (date: Date): Date[] => {
  const start = startOfDay(date);

  return [start, addDays(start, 1), addDays(start, 2)];
};
